import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/b1457fd5-a222-4e22-9f64-77c68caffa45";
export const REGISTER_URL = "https://a.ntrk2.com/47b67cdc-52fa-4d48-bd78-1f5d85b8d74d";

export const LOGIN_URL_MAP = {
  "www-w268play.com": "https://a.ntrk2.com/3a370fd4-7f17-490f-85f8-b21eab7e754b",
  "w268682.com": "https://a.ntrk2.com/3a370fd4-7f17-490f-85f8-b21eab7e754b",
};

export const REGISTER_URL_MAP = {
  "www-w268play.com": "https://a.ntrk2.com/24e1c23e-042f-4aac-88d1-00b78e6a7983",
  "w268682.com": "https://a.ntrk2.com/24e1c23e-042f-4aac-88d1-00b78e6a7983",
};

export const FLOATING_BANNER_URL = "https://w268tha.com/cs";

export const DOWNLOAD_URL = "https://w268.kzw2a.com/download?openExternalBrowser=1&id=55d81ad5nzogsw2";

export * from "./codes";
export * from "./context";
